import React from 'react'
import styles from './Pips.scss'
import _ from 'lodash'
import cx from 'classnames'

export class Pips extends React.PureComponent {
  render () {
    const {stepCount, activeIndex, onClickPip} = this.props

    return (
      <div className={styles.Pips}>
        {_.times(stepCount, i =>
          <span
            className={cx(styles.pip, activeIndex === i && styles.active)}
            onClick={() => onClickPip(i)}
            key={i} />
        )}
      </div>
    )
  }
}
